// extracted by mini-css-extract-plugin
module.exports = {"row":"OtpInput_row__1IeB_","cell":"OtpInput_cell__2XpMX","cellError":"OtpInput_cellError__2FO-J"};